import React, { useEffect, useState } from "react";
import getInvoiceData from "../../functions/invoice/getInvoiceData";
import axios from "axios";
import { notification, Spin } from "antd";
import InvoiceDescription from "../../components/side/invoiceDescription";
import Method from "../../components/side/method";
import PaidChecker from "../../functions/invoice/paidChecker";
import SuccessPaidModal from "../../components/modal/successPaid";
import { CaretLeftOutlined } from "@ant-design/icons";
import QpayBankList from "../../components/lists/qpayBankList";
import CardPaymentHandler from "../../components/modal/cardPaymentHandler";
import { useUser } from "./context.js/userContext";
import "../../styles/invoicePay.css";

const InjectedContext = ({ secureId, defaultMethod, usePaymentSession = true }) => {
  const [paymentData, setPaymentData] = useState(null);
  const [invoiceLoading, setInvoiceLoading] = useState(true);
  const [cardOpen, setCardOpen] = useState(defaultMethod === "CARD");
  const { paying, setPaying, setReturnUrl, returnUrl, setShowSuccess } =
    useUser();

  useEffect(() => {
    if (secureId) {
      fetchData();
    }
  }, [secureId]);

  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        await paidChecker();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    const t1 = setTimeout(() => paidChecker(), 4000);
    const t2 = setTimeout(() => paidChecker(), 8000);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- secureId stable for page lifetime
  }, []);

  const paidChecker = async () => {
    const response = await PaidChecker(secureId);
    if (response && response.success) setShowSuccess(true);
  };

  const fetchData = async () => {
    setInvoiceLoading(true);
    try {
      const response = await getInvoiceData(secureId);
      if (!response) {
        notification.error({ message: "Алдаа гарлаа!" });
        return;
      }

      const fullReturnUrl = `${response.returnUrl}${
        response.returnUrl.includes("?") ? "&" : "?"
      }secureId=${secureId}`;

      if (response.status === "PAID") {
        setPaying("Захиалга төлөгдсөн байна!");
        setTimeout(() => {
          window.location.href = fullReturnUrl;
        }, 2000);
      }
      setReturnUrl(fullReturnUrl);
      setPaymentData(response);
      if (defaultMethod === "CARD") {
        setCardOpen(true);
      }
      setTimeout(() => {
        window.location.href = fullReturnUrl;
      }, 10 * 60 * 1000);
    } finally {
      setInvoiceLoading(false);
    }
  };

  const back = () => {
    if (returnUrl) window.location.href = returnUrl;
  };

  const forcePay = async () => {
    try {
      await axios.get(paymentData.qpayData.callBackUrl);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch {
      notification.error({ message: "error!" });
    }
  };

  const paySplit = () => {
    notification.error({ message: "Тун удахгүй!" });
  };

  const toggleCard = () => {
    setCardOpen((open) => !open);
  };

  if (invoiceLoading || !paymentData) {
    return (
      <div className="invoice-pay-page invoice-pay-loading">
        <Spin size="large" />
        <span className="text-sm">Нэхэмжлэл ачаалж байна...</span>
      </div>
    );
  }

  return (
    <div className="invoice-pay-page flex min-h-screen w-full flex-col">
      <header className="invoice-pay-header sticky top-0 z-20">
        <div className="invoice-pay-header__bar">
          <button
            type="button"
            onClick={back}
            className="invoice-pay-back"
            aria-label="Буцах"
          >
            <CaretLeftOutlined style={{ fontSize: 18, color: "#2EA5A1" }} />
          </button>
          <div className="invoice-pay-brand">
            <img
              src="/smartpay.png"
              alt="SmartPay"
              className="invoice-pay-brand__logo"
              width={36}
              height={36}
            />
          </div>
          <div className="invoice-pay-header__end">
            {paymentData && String(paymentData.dec).includes("test") && (
              <button type="button" onClick={forcePay} className="invoice-pay-dev-pay">
                PAY
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="invoice-pay-main mx-auto flex w-full max-w-lg flex-1 flex-col px-4 pb-8">
        <InvoiceDescription data={paymentData} />
        <SuccessPaidModal merchantId={paymentData?.merchantId} />

        {/* TODO: card/split сонголтыг түр нуулаа — зөвхөн банкны аппаар төлөх */}
        {false && (
        <div className="mb-3 flex flex-row gap-3">
          <Method
            onClick={toggleCard}
            selected={cardOpen}
            icon={
              <img
                src="/card.png"
                alt=""
                className="cardAddIcon"
                width="40"
                height="40"
              />
            }
            title="Картаар төлөх"
          />
          <Method
            onClick={paySplit}
            disabled
            icon={
              <img
                src="/split.png"
                alt=""
                width="32"
                height="32"
                className="opacity-80"
              />
            }
            title="Хувааж төлөх"
            description="(одоогоор идэвхгүй)"
          />
        </div>
        )}

        <Spin
          spinning={Boolean(paying)}
          tip={paying}
          className="invoice-pay-spin w-full"
        >
          {cardOpen && (
            <div className="mb-4">
              <CardPaymentHandler invoice={paymentData} />
            </div>
          )}
          <QpayBankList
            invoiceId={paymentData?.id}
            onPaid={() => setShowSuccess(true)}
            useSessionApi={usePaymentSession}
          />
        </Spin>
      </main>
    </div>
  );
};

export default InjectedContext;
